/**
 * Converts a hex color to RGBA format with specified opacity
 * @param {string} hex - The hex color code (e.g., '#43ba0a' or '43ba0a')
 * @param {number} opacity - The opacity value (0-1, where 1 is fully opaque)
 * @returns {string} - The RGBA color string (e.g., 'rgba(67, 186, 10, 0.07)')
 */
export const convertHexToRGBA = (hex, opacity = 1) => {
	// Remove the hash if present
	const cleanHex = hex.replace('#', '')

	// Parse the hex values
	const r = parseInt(cleanHex.substring(0, 2), 16)
	const g = parseInt(cleanHex.substring(2, 4), 16)
	const b = parseInt(cleanHex.substring(4, 6), 16)

	// Return RGBA string
	return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
